<template>
  <div>
    <el-card class="box-card box-cards" shadow="never">
      <el-row>
        <el-form :inline="true" class="user-search">
          <el-col :span="24">
            <el-form-item>
              <div class="card_top"><span>反馈列表</span></div>
            </el-form-item>
            <el-form-item label="搜索：">
              <el-input size="small" v-model="formInline.params.name" placeholder="输入关键字"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="box-card box-cards2" shadow="never">
      <!--列表-->
      <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
        style="width: 100%; " v-loading="loading">
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="content" label="反馈内容" align="center" width="400"></el-table-column>
        <el-table-column prop="image" label="相关图片" align="center" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.images">
              <el-image style="width: 100px; height: 100px" :src="scope.row.images"
                :preview-src-list="scope.row.images">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="联系人" align="center" width="140"></el-table-column>
        <el-table-column prop="contact" label="联系方式" align="center" width="140"></el-table-column>

        <el-table-column prop="is_show" label="状态" align="center" width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.status == 0 ? '未处理' : '已处理' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="jtime" label="更新时间" align="center" width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.updatedAt | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="result" label="处理结果" align="center" width="160"></el-table-column>
        <el-table-column prop="jtime" label="处理时间" align="center" width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.processedAt">{{ scope.row.processedAt | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">

            <el-button v-if="scope.row.status == 0" size="mini" type="primary"
              @click="handleEdit(scope.$index, scope.row)">处理 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-card>
    <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
      custom-class="demo-drawer" ref="drawer" size="30%">
      <div class="demo-drawer__content">
        <el-row>
          <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
            <el-col :span="22">
              <div class="grid-content bg-purple">
                <el-form-item label="反馈内容:" prop="name">
                  {{ editForm.params.content }}
                </el-form-item>
                <el-form-item label="图片:" prop="name">
                  <div v-if="editForm.params.images">
                    <el-image style="width: 100px; height: 100px" :src="editForm.params.images"
                      :preview-src-list="editForm.params.images">
                    </el-image>
                  </div>
                </el-form-item>
                <el-form-item label="处理回复:" prop="name">
                  <el-input v-model="editForm.params.result" placeholder="请输入处理回复"></el-input>
                </el-form-item>

              </div>
            </el-col>

          </el-form>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleClose">取消</el-button>
          <el-button size="small" type="goon" class="title" @click="submitForm('editForm')">
            保存</el-button>
        </div>
        <div style="height: 60px; margin-top: 50px"></div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { feedbacklist, feedbackupdate } from "../../api/userMG";
export default {
  data() {
    return {
      title: "信息",
      options: [],
      editFormVisible: false,
      //分页
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      tableData: [], //表格数据 
      formInline: {
        data: {},
        params: {
          pageNum: 1,
          pageSize: 10,
          name: ""
        },
      },
      dialogImageUrl: '',
      dialogVisible: false,
      //添加，修改数据
      editForm: {
        data: {},
        params: {
          "contact": "example@email.com",
          "content": "",
          "id": 1,
          "images": "",
          "name": "",
          "result": "",
          "status": 1
        },
      },
      //规则验证
      rules: {},
    };
  },
  components: {
    Pagination
  },
  created() {
    //数据列表
    this.getlist(this.formInline);
  },
  methods: {
    headStyle() {
      return {
        background: "#A1BBFF",
        color: "#fff",
        letterSpacing: "2px",
        border: " 1px solid #A1BBFF",
        textAlign: "center",
        height: "39px",
      };
    },

    //显示数据
    getlist(parameter) {
      this.loading = true;
      feedbacklist(parameter)
        .then((res) => {
          this.loading = false;
          // console.log("userlist", res);
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.tableData = res.data.records;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.params.pageNum;
            this.pageparm.pageSize = this.formInline.params.pageSize;
            this.pageparm.total = res.data.total;
            // console.log(this.tableData)
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.params.pageNum = parm.currentPage;
      this.formInline.params.pageSize = parm.pageSize;
      this.getlist(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.params.pageNum = 1;
      this.getlist(this.formInline); //显示
    },
    //关闭弹框
    handleClose(done) {
      this.$confirm("还有未保存的工作哦确定关闭吗？")
        .then((_) => {
          this.editFormVisible = false
          // done();
        })
        .catch((_) => { });
    },
    //上传头像


    //添加，修改
    handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = {

        data: {},
        params: {
          "id": row.id,
          "contact": row.contact,
          "content": row.content,
          "images": row.images,
          "name": row.name,
          "result": "",
          "status": 1
        },
      }


    },
    //提交添加，修改
    submitForm(info) {

      debounce(() => {

        feedbackupdate(this.editForm)
          .then(res => {
            if (res.code == 200) {
              this.editFormVisible = false;
              this.getlist(this.formInline);
              this.$message({
                message: "保存成功！",
                type: "success",
              });
            } else {
              this.$message({
                type: "info",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.$message.error("保存失败，请稍后再试！");
          });



      }, 1500);
    },

  },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.divBox {
  /*flex-direction: row;*/
  float: left;
  position: relative;
  margin-right: 10px;
}

.imgSty {
  margin-left: 3px;
}

.delIcon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 145px;
  height: 145px;
  line-height: 145px;
  text-align: center;
}

.avatar {
  width: 145px;
  height: 145px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/feedback/list.vue